import { Skeleton, Box, Stack } from '@mui/material';

export const AuthorCardSkeleton = () => (
  <Box 
    sx={{
      p: 2,
      height: '100%',
      border: '1px solid rgba(110, 59, 255, 0.2)',
      borderRadius: '12px',
      background: 'linear-gradient(145deg, rgba(26,9,51,0.5) 0%, rgba(15,5,29,0.5) 100%)',
    }}
  >
    <Stack spacing={2} alignItems="center">
      {/* Аватар */}
      <Skeleton 
        variant="circular" 
        width={80} 
        height={80}
        sx={{ bgcolor: 'rgba(110, 59, 255, 0.3)' }}
      />
      
      {/* Имя автора */}
      <Skeleton 
        variant="text" 
        width="60%" 
        height={32}
        sx={{ 
          bgcolor: 'rgba(110, 59, 255, 0.3)',
          borderRadius: '4px'
        }}
      />
      
      {/* Блок статистики */}
      <Box sx={{ 
        display: 'flex', 
        width: '100%', 
        justifyContent: 'space-between',
        mt: 2
      }}>
        <Box sx={{ textAlign: 'center' }}>
          <Skeleton 
            variant="text" 
            width={60} 
            height={20}
            sx={{ bgcolor: 'rgba(110, 59, 255, 0.2)' }}
          />
          <Skeleton 
            variant="text" 
            width={40} 
            height={24}
            sx={{ bgcolor: 'rgba(110, 59, 255, 0.3)' }}
          />
        </Box>
        
        <Box sx={{ textAlign: 'center' }}>
          <Skeleton 
            variant="text" 
            width={60} 
            height={20}
            sx={{ bgcolor: 'rgba(110, 59, 255, 0.2)' }}
          />
          <Skeleton 
            variant="text" 
            width={40} 
            height={24}
            sx={{ bgcolor: 'rgba(110, 59, 255, 0.3)' }}
          />
        </Box>
      </Box>
      
      {/* Бейдж верификации */}
      <Skeleton 
        variant="rectangular" 
        width={80} 
        height={24}
        sx={{ 
          mt: 2,
          borderRadius: '12px',
          bgcolor: 'rgba(110, 59, 255, 0.2)'
        }}
      />
    </Stack>
  </Box>
);